import { TableHeader, type TableSortOrder } from '@/components/Table'
import { jobTableColumnStyles } from '@/features/jobs/list/components/JobManagement/JobsTable'
import { type ColumnId } from '@/features/jobs/list/jobs-table-columns'

export interface UserDetailsJobsTableHeaderColumn {
  id: ColumnId
  header: string
  sortable: boolean
  sortOrder: TableSortOrder
  onSort: (direction: TableSortOrder) => void
}

export interface UserDetailsJobsTableHeaderRowProps {
  /**
   * The visible columns.
   */
  columns: UserDetailsJobsTableHeaderColumn[]
}

export function UserDetailsJobsTableHeaderRow({
  columns,
}: UserDetailsJobsTableHeaderRowProps) {
  return (
    <>
      {columns.map((col) => (
        <TableHeader
          key={col.id}
          className={jobTableColumnStyles[col.id]}
          canSort={col.sortable}
          align="left"
          sortOrder={col.sortOrder}
          onSort={col.onSort}
        >
          {col.header}
        </TableHeader>
      ))}
    </>
  )
}
